import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ccbcabde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "carousel" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "lp_image_wrapper" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "lp_title" }
const _hoisted_6 = { class: "lp_text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_swiper, {
      cssMode: true,
      navigation: true,
      pagination: _ctx.pagination,
      mousewheel: true,
      keyboard: true,
      modules: _ctx.modules,
      class: "mySwiper"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.SlidePages, (slide, number) => {
          return (_openBlock(), _createBlock(_component_swiper_slide, { key: number }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slide, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.Id + index,
                  class: _normalizeClass(["landing_page_wrapper", _ctx.selectedPage && _ctx.selectedPage.Id === item.Id ? 'selected' : '']),
                  onClick: ($event: any) => (_ctx.selectPage(item))
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("img", {
                      class: "img-content",
                      src: item.PreviewPath
                    }, null, 8, _hoisted_4)
                  ]),
                  _createElementVNode("p", _hoisted_5, _toDisplayString(item.Title), 1),
                  _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.lastUpdatedString(item.UpdatedAt)), 1)
                ], 10, _hoisted_2))
              }), 128))
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }, 8, ["pagination", "modules"])
  ]))
}